import { useEffect, useState } from 'react';
import api from '../config/api';

// Public platform settings from the admin panel (app name, logo, support contact). Fetched once per page load.
let settingsPromise = null;

const loadSettings = () => {
  if (!settingsPromise) {
    settingsPromise = api
      .get('/settings')
      .then((res) => res.data || {})
      .catch(() => {
        settingsPromise = null; // retry on the next mount
        return {};
      });
  }
  return settingsPromise;
};

/** Support text using whatever contact details the admin set (email, phone, both or neither). */
export const supportContactText = (t, settings = {}) => {
  const email = settings.contactEmail || '';
  const phone = settings.contactPhone || '';
  if (email && phone) return t('supportContactMessage').replace('{email}', email).replace('{phone}', phone);
  if (email) return t('supportContactEmailOnly').replace('{email}', email);
  if (phone) return t('supportContactPhoneOnly').replace('{phone}', phone);
  return t('supportContactNone');
};

const usePublicSettings = () => {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    let active = true;
    loadSettings().then((data) => active && setSettings(data));
    return () => { active = false; };
  }, []);
  return settings;
};

export default usePublicSettings;
